import React, { useEffect, useRef } from "react";
import { useState } from "react";
import * as Navigation from "../../../specific/utils/Navigation/Navigation";

import {
    View,
    ActivityIndicator,
    Animated,
    Platform
} from 'react-native';

import AppTheme from "../../utils/Theme";
import * as Constants from "../../utils/Constants";

// Assets
import Images from "../../../specific/utils/Images";

import { useNavigate, useParams } from "../../../specific/utils/Navigation/Navigation";

import { analyticsEventHpLoungeClicked, analyticsEventHpSuperPowerClicked, analyticsEventHpViewed, propertiesEventHpLoungeStartingPoint, propertiesEventSuperPower, propertiesValueHpLoungeStartingPointSection, propertiesValueHpLoungeStartingPointSuperpower, trackEvent } from "../../services/Tracking/Analytics";
import User from "../../data/user/User";
import InViewModal from "../../../specific/components/InViewModal/InViewModal";
import DeepLink from "../../services/DeepLink/DeepLink";
import MainOptions from "../../models/MainOptions";
import Main from "../../../specific/components/Main/Main";
import { handleUrl } from "../../../specific/utils/Deeplink/Deeplink";
import MenuSegment from "../../services/MenuSegment/MenuSegment";
import ComponentProps from "../../../specific/utils/Interfaces/ComponentProps";
import ActivitiesMenu from "./ActivitiesMenu";
import SequencesMenu from "./SequencesMenu";
import SuperRoom from "../Rooms/SuperRoom";
import UserProfile from "../Profile/UserProfile";
import { getLocalMenuSettings } from "../../../specific/utils/LocalStorage";
import MenuSettingsBundle from "../../data/jsons/local_db_menu_settings.json";
import UserLevelSelection from "../Filters/UserLevelSelection";
import MenuCell from "./MenuCell";
import { EventRegister } from "../../utils/EventListeners";
import PremiumScreen from "../../screens/premium/PremiumScreen";
import FamilyRoom from "../../screens/rooms/FamilyRoom";
import InstitutionRoom from "../../screens/rooms/InstitutionRoom";

export type APP_MENU_SCREENS = "ACTIVITIES" | "SEQUENCES" | "ROOM" | "SUB" | "ACCOUNT" | "EMPTY" | "PREMIUM" | "ACCOUNT_PREM";

export type SectionsMenuSettings = {

}

export type ActivitiesMenuSettings = {
    cover: {
        all: string[];
        teacher?: string[];
        family?: string[];
        animator?: string[];
    };
    sections: {
        all: SectionsMenuSettings[]
    }
}

type MenuSettings = {
    activities: ActivitiesMenuSettings
}

interface AppMenuProps extends ComponentProps {
    submenu: string;
}

const AppMenu = (props: AppMenuProps) => {

    const user: User = User.getInstance();

    const [viewDidAppear, setViewDidAppear] = useState<boolean>(false);

    const [selectedMenuScreen, setSelectedMenuScreen] = useState<APP_MENU_SCREENS | undefined>(Platform.OS === "web" ? undefined : "ROOM");
    const [appMenuSettings, setAppMenuSettings] = useState<MenuSettings | undefined>(undefined);

    const [showLevelSelection, setShowLevelSelection] = useState<boolean>(false);

    const [menuType, setMenuType] = useState<number>(0);

    const menuSegment: MenuSegment = MenuSegment.getInstance();

    const appTheme: AppTheme = new AppTheme();

    const mainViewOpacity: Animated.Value = useRef(new Animated.Value(1)).current;
    const menuTypeValue: Animated.Value = useRef(new Animated.Value(0)).current;

    const inViewModal = useRef<InViewModal>(null);

    let propsData = props;
    let navigate: any = null;
    if (Platform.OS === "web") {
        propsData = useParams();
        navigate = useNavigate();
    }

    const { componentId = "", submenu } = props;


    const mainOptions: MainOptions = new MainOptions({
        key: "app_menu",
        componentId,
        showNavBar: false,
        showMenu: false,
        safeArea: false,
        canGoBack: false
    });

    useEffect(() => {
        if (selectedMenuScreen === undefined) {
            if (Platform.OS === "web") {
                console.log(location.pathname);
                if (location.pathname === "/appMenu/activities") {
                    setSelectedMenuScreen("ACTIVITIES");
                } else if (location.pathname === "/appMenu/sequences") {
                    setSelectedMenuScreen("SEQUENCES");
                } else if (location.pathname === "/appMenu/account") {
                    setSelectedMenuScreen("ACCOUNT");
                } else if (location.pathname === "/appMenu/premium") {
                    setSelectedMenuScreen("PREMIUM");
                } else {
                    setSelectedMenuScreen("ROOM");
                }
            }
        }
    }, [selectedMenuScreen]);

    // ComponentDidMount
    useEffect(() => {
        EventRegister.addEventListener("userSubUpdated", () => {
            setSelectedMenuScreen((prev) => {
                if (prev === "PREMIUM") {
                    return "ACCOUNT";
                } else {
                    console.log({ prev });
                    return prev;
                }
            });
        });
        EventRegister.addEventListener("newMenuSelection", (menuSelected: APP_MENU_SCREENS) => {
            setSelectedMenuScreen(menuSelected);
        });
        return () => {
            EventRegister.removeEventListener("userSubUpdated");
            EventRegister.removeEventListener("newMenuSelection");
        };
    }, []);

    useEffect(() => {
        if (appMenuSettings === undefined) {
            onViewWillAppear();
        } else {
            setViewDidAppear(true);
        }
    }, [appMenuSettings])

    const onViewWillAppear = () => {
        if (user.children_level === undefined) {
            setShowLevelSelection(true);
        }
        trackEvent(analyticsEventHpViewed);
        getMenuSettings();
        const deepLink: DeepLink = DeepLink.getInstance();
        if (deepLink.path.length > 0) {
            handleDeepLink(deepLink.path);
            deepLink.path = "";
        }
    }

    const getMenuSettings = async () => {
        try {
            const localMenuSettings: { ts: number; data: MenuSettings } = await getLocalMenuSettings();
            if (localMenuSettings.data !== undefined) {
                setAppMenuSettings(localMenuSettings.data);
            } else {
                setAppMenuSettings(MenuSettingsBundle.data);
            }
        } catch (error) {
            setAppMenuSettings(MenuSettingsBundle.data);
        }
    }

    const handleDeepLink = (path: string) => {
        // Au lancement du splashscreen on a récupéré l'initial URL
        // Ici on va l'analyser
        console.log({ path });
        if (path.includes("/appMenu") === true) {
            if (path.includes("/appMenu/skills") === true) {
                if ((user.profile === "teacher") || (user.profile === "animator")) {
                    onSelectMenuItem(1);
                } else {
                    onSelectMenuItem(0);
                }
            } else {
                let deeplinkScreen: APP_MENU_SCREENS | undefined = undefined;
                if (path.includes("/appMenu/activities") === true) {
                    deeplinkScreen = "ACTIVITIES";
                } else if (path.includes("/appMenu/sequences") === true) {
                    deeplinkScreen = "SEQUENCES";
                } else if (path.includes("/appMenu/room") === true) {
                    deeplinkScreen = "ROOM";
                } else if (path.includes("/appMenu/account") === true) {
                    deeplinkScreen = "ACCOUNT";
                }
                if (deeplinkScreen !== undefined) {
                    setSelectedMenuScreen(deeplinkScreen);
                    EventRegister.emit(Constants.EventMenuSelectedChanged, deeplinkScreen);
                }
            }
        } else {
            if (Platform.OS === "web") {
                const directCorrespondanceForSuperRoom = {
                    "/selectSubscription": "sub",
                    "/philo": "philo",
                    "/categoryHome/phi_questions": "philo",
                    "/wellBeing": "well_being",
                    "/categoryHome/wellBeing": "well_being",
                    "/advices": "advices",
                    "/activityTypes": "activity_types",
                    "/superRoom": ""
                }
                for (const aDirectCorrespondaceKey in directCorrespondanceForSuperRoom) {
                    if (Object.prototype.hasOwnProperty.call(directCorrespondanceForSuperRoom, aDirectCorrespondaceKey)) {
                        const aTarget: string = directCorrespondanceForSuperRoom[aDirectCorrespondaceKey];
                        if (path.includes(aDirectCorrespondaceKey) === true) {
                            goToSuperRoom(aTarget);
                            break;
                        }
                    }
                }
                if (path.includes("/cardActivation") === true) {
                    goToUserProfile(path);
                } else if (path.includes("/stripeCallBack") === true) {
                    let urlArguments: string[] = path.split("/");
                    const subId: string = urlArguments[urlArguments.length - 1];
                    const status: string = urlArguments[urlArguments.length - 2];
                    goToSuperRoom("sub", { status, subId });
                } else if (path.includes("/activitiesBySection") === true) {
                    let section = { key: "" };
                    let sectionsKeys: string[] = ["still", "talk", "grow", "liliAtSchool"];
                    for (const aSectionKeyIndex in sectionsKeys) {
                        if (Object.prototype.hasOwnProperty.call(sectionsKeys, aSectionKeyIndex)) {
                            const aSectionKey: string = sectionsKeys[aSectionKeyIndex];
                            if (path.includes(aSectionKey) === true) {
                                section.key = aSectionKey;
                                launchTheApp({ section });
                                break;
                            }
                        }
                    }
                } else if (path.includes("/activitySheet") === true) {
                    // Quelque soit l'origine, on aura toujours la section en dernier, la catégorie en avant-dernier et enfin le code de l'activité en avant-avant-dernier
                    let urlArguments: string[] = path.split("/");
                    const activityKey: string = urlArguments[urlArguments.length - 3];
                    const categoryKey: string = urlArguments[urlArguments.length - 2];
                    const sectionKey: string = urlArguments[urlArguments.length - 1];
                    if (activityKey.indexOf("SHE_") !== -1) {
                        // Open modal
                        launchActivity({ activityKey, sectionKey, categoryKey });
                    } else {
                        const deepLink: DeepLink = DeepLink.getInstance();
                        deepLink.category_key = categoryKey;
                        deepLink.activity_key = activityKey;

                        launchTheApp({ section: { key: sectionKey } });
                    }
                } else if (path.includes("/categoryHome") === true) {
                    let urlArguments: string[] = path.split("/");
                    const categoryKey: string = urlArguments[urlArguments.length - 3];
                    const sectionKey: string = urlArguments[urlArguments.length - 2];
                    launchCategory({ sectionKey, categoryKey });
                } else if (path.includes("/program_activity") === true) {
                    let urlArguments: string[] = path.split("/");
                    const programKey: string = urlArguments[urlArguments.length - 2];
                    const activityKey: string = urlArguments[urlArguments.length - 1];
                    console.log({ activityKey, programKey });
                    if (programKey === "family") {
                        onActivityFromPlaylistRequest(activityKey);
                    }
                } else if (path.includes("/program") === true) {
                    let urlArguments: string[] = path.split("/");
                    const programKey: string = urlArguments[urlArguments.length - 2];
                    const activityKey: string = urlArguments[urlArguments.length - 1];
                    console.log({ activityKey, programKey });
                    if (programKey === "family") {
                        onActivityPlaylistRequest(activityKey);
                    }
                } else if (path.includes("/superPowersPlaylist") === true) {
                    let urlArguments: string[] = path.split("/");
                    const superPowerKey: string = urlArguments[urlArguments.length - 1];
                    console.log({ superPowerKey });
                    if (superPowerKey !== undefined) {
                        launchSuperProgram(superPowerKey);
                    }
                }
            } else {
                handleUrl({ url: path, isLaunchedUrl: false, componentId, navigate });
            }
        }

        setViewDidAppear(true);
    }

    const onActivityFromPlaylistRequest = (activityKey: string) => {
        if (Platform.OS === "web") {
            Navigation.showModalInView({
                componentId,
                navigate,
                name: Constants.ScreenActivitySheetScreen,
                passProps: {
                    activityId: activityKey
                }
            })
        }
    }

    const onActivityPlaylistRequest = (activityKey: string) => {
        if (Platform.OS === "web") {
            Navigation.showModalInView({
                componentId,
                navigate,
                name: Constants.ScreenActivityPlaylist,
                passProps: {
                    activityId: activityKey
                }
            })
        }
    }

    const launchSuperProgram = (superProgramKey: string) => {
        if (Platform.OS === "web") {
            EventRegister.emitEvent("newMenuSelection", "SEQUENCES"); 
        } else {
            setSelectedMenuScreen("SEQUENCES");
        }
        trackEvent(analyticsEventHpSuperPowerClicked, { [propertiesEventSuperPower]: superProgramKey });
        Navigation.push({
            componentId,
            navigate,
            passProps: {
                superPowersKey: superProgramKey,
                context: Constants.CONTEXT.family
            },
            name: Constants.ScreenSuperPowersPlaylist
        });
    }

    const goToUserProfile = (path?: string, stripe?: { status: string, subId: string }) => {
        Navigation.showModalInView({
            componentId,
            name: Constants.ScreenUserProfile,
            passProps: {
                isModal: true,
                isTeacher: true,
                path,
                stripe
            }
        });
    }

    const goToSuperRoom = (path?: string, stripe?: { status: string, subId: string }) => {
        /*** STAT ***/
        const loungeRoomByProfile = {
            "family": "parent_lounge",
            "animator": "animator_lounge",
            "teacher": "teacher_lounge"
        }
        const activitiesByTypeIndex = user.profile === "family" ? 1 : 0;
        if (loungeRoomByProfile[user.profile] !== undefined) {
            trackEvent(analyticsEventHpLoungeClicked, {
                "room": loungeRoomByProfile[user.profile],
                [propertiesEventHpLoungeStartingPoint]: menuType === activitiesByTypeIndex ? propertiesValueHpLoungeStartingPointSection : propertiesValueHpLoungeStartingPointSuperpower
            });
        }
        /*** STAT ***/
        let superRoomPath: string = path !== undefined ? path : "";
        Navigation.showModalInView({
            componentId,
            name: Constants.ScreenSuperRoom,
            passProps: {
                isModal: true,
                path: superRoomPath,
                stripe
            }
        });
    }

    const launchTheApp = (data: { section: any }) => {
        const { section } = data;
        const { key } = section;
        if ((key === "still") || (key === "talk") || (key === "grow") || (key === "liliAtSchool") || (key === "inspire")) {
            if (key === "still") {
                trackEvent("section_calm_clicked");
            } else if (key === "talk") {
                trackEvent("section_expression_clicked");
            } else if (key === "grow") {
                trackEvent("section_philo_clicked");
            } else if (key === "inspire") {
                trackEvent("section_inspire_clicked");
            }
            Navigation.push({
                componentId,
                navigate,
                name: Constants.ScreenActivitiesBySection,
                passProps: {
                    sectionKey: key
                }
            });
        }
    }

    const launchCategory = (data: { categoryKey: string; sectionKey: string; }) => {
        const { categoryKey, sectionKey } = data;
        let passProps = {
            categoryKey,
            sectionKey,
            starting_point: "section",
            section: sectionKey,
            origin: "menu"
        }

        if (Platform.OS === "web") {
            Navigation.push({
                componentId,
                name: Constants.ScreenCategoryHome,
                passProps
            });
        } else {
            Navigation.showModal({
                componentId,
                navigate,
                passProps,
                name: Constants.ScreenCategoryHome
            });
        }
    }

    const launchActivity = (data: { activityKey: string; categoryKey: string; sectionKey: string; }) => {
        const { activityKey, sectionKey, categoryKey } = data;
        let name = Constants.ScreenActivitySheet;
        let passProps = {
            activityKey,
            categoryKey,
            sectionKey,
            context: user.profile,
            isModal: true,
            showBg: false
        };
        //trackEvent(analyticsEventHpTrainingPathClicked);
        if (Platform.OS === "web") {
            launchInViewModal({ name, passProps });
        } else {
            Navigation.showModal({
                componentId,
                navigate,
                passProps,
                name
            });
        }
    }

    const launchInViewModal = (data: { name, passProps }) => {
        const { name, passProps } = data;
        if (inViewModal.current !== null) {
            inViewModal.current?.showAlert({
                name,
                passProps
            });
        } else {
            setTimeout(() => {
                launchInViewModal({ name, passProps });
            }, 200);
        }

    }

    const onSelectMenuItem = (menuItemIndex: number) => {
        Animated.parallel([
            Animated.sequence([
                Animated.timing(mainViewOpacity, {
                    toValue: 0,
                    duration: 500,
                    useNativeDriver: true
                }),
                Animated.timing(mainViewOpacity, {
                    toValue: 1,
                    duration: 500,
                    useNativeDriver: true
                })
            ]),
            Animated.timing(menuTypeValue, {
                toValue: 1 - menuType,
                duration: 500,
                useNativeDriver: false
            })
        ]).start(() => {

        });
        setTimeout(() => {
            setMenuType(menuItemIndex);
        }, 500);
    }

    const renderFooter = () => {
        if ((Platform.OS === "web") && (appTheme.getFlexDirectionForSplitScreen() === "row")) {
            return <View />
        }
        let width: number = appTheme.getFullAppWidth();
        let height: number | string = appTheme.bottomInsets === 0 ? appTheme.pixelPerfect(70) : appTheme.bottomInsets + appTheme.pixelPerfect(60);
        let premiumCell: React.JSX.Element | null = null;
        if (user.isPremium() === false) {
            premiumCell = <MenuCell key="PREMIUM" width={width} menuScreenId="PREMIUM" isSelected={selectedMenuScreen === "PREMIUM"} onSelectedMenuChange={setSelectedMenuScreen} />;
        }

        let roomCell: React.JSX.Element = <MenuCell key="ROOM" width={width} menuScreenId="ROOM" isSelected={selectedMenuScreen === "ROOM"} onSelectedMenuChange={setSelectedMenuScreen} />;
        let activitiesCell: React.JSX.Element = <MenuCell key="ACTIVITIES" width={width} menuScreenId="ACTIVITIES" isSelected={selectedMenuScreen === "ACTIVITIES"} onSelectedMenuChange={setSelectedMenuScreen} />;
        let sequencesCell: React.JSX.Element = <MenuCell key="SEQUENCES" width={width} menuScreenId="SEQUENCES" isSelected={selectedMenuScreen === "SEQUENCES"} onSelectedMenuChange={setSelectedMenuScreen} />;
        let firstCells: React.JSX.Element[] = [roomCell, sequencesCell, activitiesCell];
        return <View style={{ position: Platform.OS === "web" ? "sticky" : "absolute", bottom: 0, width, height, backgroundColor: "#FFFFFF", flexDirection: "row", justifyContent: "space-evenly", alignItems: "center", paddingBottom: appTheme.bottomInsets }}>
            {firstCells}
            {premiumCell}
            <MenuCell key="ACTIVITIACCOUNTES" width={width} menuScreenId="ACCOUNT" isSelected={selectedMenuScreen === "ACCOUNT"} onSelectedMenuChange={setSelectedMenuScreen} />
        </View>
    }

    const renderAppMenuPage = () => {
        // En WEB, on va regarder 2 choses - le selectedMenuScreen, mais surtout l'URL de la fenêtre
        let menuScreenToDisplay: APP_MENU_SCREENS = selectedMenuScreen;
        if (Platform.OS === "web") {
            let urlOfThePage: string = window.location.href;
            if (urlOfThePage.includes("/appMenu/sequences") === true) {
                menuScreenToDisplay = "SEQUENCES";
            } else if (urlOfThePage.includes("/appMenu/room") === true) {
                menuScreenToDisplay = "ROOM";
            } else if (urlOfThePage.includes("/appMenu/account") === true) {
                menuScreenToDisplay = "ACCOUNT";
            } else if (urlOfThePage.includes("/appMenu/premium") === true) {
                menuScreenToDisplay = "PREMIUM";
            }
        }
        if (menuScreenToDisplay === "ACTIVITIES") {
            return <ActivitiesMenu componentId={componentId} settings={appMenuSettings?.activities} launchTheApp={launchTheApp} />;
        } else if (menuScreenToDisplay === "SEQUENCES") {
            return <SequencesMenu componentId={componentId} />;
        } else if (menuScreenToDisplay === "ROOM") {
            if (user.profile === "family") {
                return <FamilyRoom componentId={componentId} />
            } else if ((user.profile === "teacher") || (user.profile === "animator")) {
                return <InstitutionRoom componentId={componentId} />
            }
            return <SuperRoom componentId={componentId} />
        } else if (menuScreenToDisplay === "ACCOUNT") {
            return <UserProfile componentId={componentId} />
        } else if (menuScreenToDisplay === "PREMIUM") {
            return <PremiumScreen componentId={componentId} />
        }
    }

    const renderMenuContent = () => {
        console.log({ selectedMenuScreen })
        if ((viewDidAppear === false) || (user.children_level === undefined)) {
            return <View style={{ flex: 1, width: appTheme.getFullAppWidth(), backgroundColor: appTheme.daySkyColor, justifyContent: "center", alignItems: "center" }}>
                <ActivityIndicator color={appTheme.darkBlue} />
            </View>
        }
        return <View style={{ flex: 1, width: appTheme.getFullAppWidth() }}>
            {renderAppMenuPage()}
            {renderFooter()}
        </View>
    }


    const toogleLevelSelection = () => {
        setShowLevelSelection(false);
    }

    return (
        <Main mainOptions={mainOptions}>
            {renderMenuContent()}
            <InViewModal ref={inViewModal} />
            <UserLevelSelection
                visible={showLevelSelection}
                style={{ flex: 1, justifyContent: "flex-end" }}
                backgroundColor={appTheme.schoolColor}
                toggleFilters={toogleLevelSelection} />
        </Main>
    )
}

export default AppMenu;

